import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

/**
 * Floating "💬 Feedback" trigger pinned to the bottom-left corner.
 *
 * Visible only to signed-in users. Hidden on:
 *  - The auth pages (sign-in / sign-up / eula) — Header is minimal there too.
 *  - The /feedback page itself — would be redundant.
 *  - The /admin/* pages — too noisy when configuring.
 */
export function FeedbackTrigger() {
  const navigate = useNavigate();
  const { isSignedIn, isLoaded } = useUser();
  const { pathname } = useLocation();

  const hideOn =
    !isLoaded ||
    !isSignedIn ||
    pathname === '/feedback' ||
    pathname.startsWith('/admin') ||
    pathname.startsWith('/sign-in') ||
    pathname.startsWith('/sign-up') ||
    pathname === '/eula';

  if (hideOn) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/feedback')}
      aria-label="Send feedback"
      style={{
        position: 'fixed',
        bottom: 24,
        left: 24,
        zIndex: 9998,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '10px 16px',
        background: 'rgba(20, 22, 35, 0.92)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: '1px solid rgba(114,164,242,0.4)',
        borderRadius: 999,
        color: 'var(--vps-blue-200, #cfe1ff)',
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
        boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
        transition: 'transform 0.15s, box-shadow 0.15s, border-color 0.15s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.5)';
        e.currentTarget.style.borderColor = 'rgba(114,164,242,0.7)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.4)';
        e.currentTarget.style.borderColor = 'rgba(114,164,242,0.4)';
      }}
    >
      <span aria-hidden="true">💬</span>
      Feedback
    </button>
  );
}
